export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'ph1c3xJXXMpaa9HU7NVUmh1Mdk5qs1tS',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'ph1c3xJXXMpaa9HU7NVUmh1Mdk5qs1tS',
        audience: 'https://crew-time/api',
    }
}